import React, { useMemo } from 'react';
import { Button } from '@material-ui/core';
import LinearProgressBar from '../../../shared/progress-bar/Progress';

const FooterButton = (props) => {
  const {
    onNextClick,
    handleSubmit,
    onCancel,
    loading,
    maxtab,
    tabValue,
    isUpdate,
    isTabInValid,
    hasVideoError,
    isThumbnailUploading,
    isVideoLoading,
    isGifLoading,
    isNextDisabled = false,
  } = props;

  const isDisabled = useMemo(() => {
    if (isTabInValid || loading || hasVideoError || isThumbnailUploading || isVideoLoading || isGifLoading) {
      return true;
    }
    return false;
  }, [isTabInValid, loading, hasVideoError, isThumbnailUploading, isVideoLoading, isGifLoading]);

  return (
    <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
      <div className='col-md-12 d-flex justify-content-start'>
        {tabValue < maxtab ? (
          <Button
            variant='contained'
            color='primary'
            onClick={onNextClick}
            disabled={
              isTabInValid ||
              hasVideoError ||
              isThumbnailUploading ||
              isVideoLoading ||
              isGifLoading ||
              isNextDisabled
            }
            size='large'
            className='me-3'
          >
            Next
          </Button>
        ) : (
          <Button
            disabled={isDisabled}
            onClick={handleSubmit}
            variant='contained'
            color='primary'
            className='me-3'
            size='large'
          >
            {isUpdate ? 'Update' : 'Add'}
          </Button>
        )}
        <Button
          disabled={loading}
          variant='outlined'
          type='button'
          color='secondary'
          size='large'
          onClick={(e) => onCancel(e)}
        >
          Cancel
        </Button>
      </div>
      {loading && <div className='pt-4 col-md-12'>{<LinearProgressBar />}</div>}
    </div>
  );
};

export default FooterButton;
